<script setup lang="ts">
import NavBar from '@/components/navbar/NavBar.vue'
import BaseButton from '@/components/common/BaseButton.vue'

// A full reload, not a client-side route change — the app crashed mid-session,
// so whatever broke is still sitting in memory; only a fresh load of the JS
// bundle actually clears it. "Back to Home" alone would just re-render the
// same broken app shell at a different route.
function refresh() {
  window.location.href = '/'
}
</script>

<template>
  <NavBar />
  <div class="flex flex-col items-center justify-center gap-4 px-6 py-24 text-center">
    <p class="font-primary text-6xl font-bold text-navy">⚠</p>
    <h1 class="font-primary text-2xl font-bold text-navy">Something went wrong</h1>
    <p class="max-w-md text-navy/60">
      Please refresh the page and try again. If this keeps happening, contact us and we'll take a
      look.
    </p>
    <BaseButton type="button" @click="refresh">Refresh Page</BaseButton>
  </div>
</template>

<style scoped></style>
